import { localStorageInstance } from "./localStorage";
import SecureSessionStorage from "./sessionStorage";
const sessionStorageInstance = new SecureSessionStorage();

export function getStoredValue(key) {
  // Try to get from session first, fall back to local
  const sessionValue = sessionStorageInstance.getItem(key);
  if (sessionValue !== null && sessionValue !== undefined) {
    return sessionValue;
  }
  return localStorageInstance.getItem(key);
}

export function isImpersonationSessionActive() {
  // An impersonation session is active if sessionStorage has "token"
  return Boolean(sessionStorageInstance.getItem("token"));
}

export function persistImpersonationSession(
  data,
  storage = window.sessionStorage
) {
  const newSessionInstance = new SecureSessionStorage(storage);

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      newSessionInstance.setItem(key, value);
    }
  });
}

export function persistActiveAuthTokens({ token, refresh_token }) {
  // If impersonation session is active, store tokens in sessionStorage, else use localStorage
  if (isImpersonationSessionActive()) {
    persistImpersonationSession({
      token,
      refresh_token,
    });
    return;
  }

  localStorageInstance.setItem({
    key: "token",
    value: token,
  });
  localStorageInstance.setItem({
    key: "refresh_token",
    value: refresh_token,
  });
}

export function clearActiveAuthSession() {
  if (isImpersonationSessionActive()) {
    sessionStorageInstance.clear();
    return;
  }

  localStorageInstance.clear();
}

export function isStoredRole(role) {
  return getStoredValue("role") === role;
}
